import React, { useState, useEffect } from 'react';
import AdminPanel from '../panel/AdminPanel';
import { FaChalkboardTeacher, FaUserGraduate, FaUserCheck } from 'react-icons/fa';
import '../styles/ComposeNoticeDashboard.css';
import api from "../../../api/api";

const ComposeNoticeDashboard = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [formData, setFormData] = useState({
    recipientId: '',
    title: '',
    details: '',
  });

  const [students, setStudents] = useState([]);
  const [teachers, setTeachers] = useState([]);

  // Fetch students and teachers
  useEffect(() => {
   api.get("/api/students")
  .then(res => {
    setStudents(res.data);
  })
  .catch(err => console.error(err));

    api.get("/api/teachers")
      .then(res => res.data)
      .then(data => {
        console.log('teachers:', data); // debug
        setTeachers(data);
      })
      .catch(err => console.error(err));
  }, []);

  const noticeLinks = [
    { label: 'Notice for Teachers', type: 'ALL_TEACHERS', icon: <FaChalkboardTeacher />, className: 'notice-teachers' },
    { label: 'Notice for Students', type: 'ALL_STUDENTS', icon: <FaUserGraduate />, className: 'notice-students' },
    { label: 'Notice for Selected Students', type: 'SELECTED_STUDENTS', icon: <FaUserCheck />, className: 'notice-selected-students' },
    { label: 'Notice for Selected Teachers', type: 'SELECTED_TEACHERS', icon: <FaUserCheck />, className: 'notice-selected-teachers' },
  ];

  const handleNoticeClick = (notice) => {
    setSelectedNotice(notice);
    setFormData({ recipientId: '', title: '', details: '' });
    setModalOpen(true);
  };

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      notice_type: selectedNotice.type,
      recipient_ids: formData.recipientId ? [formData.recipientId] : [],
      title: formData.title,
      details: formData.details,
    };

    try {
      const res = await api.post("/api/notices", payload);
      const data = await res.data;
      console.log('Notice saved:', data);
      setModalOpen(false);
    } catch (err) {
      console.error(err);
    }
  };

  const getRecipients = () => {
    if (!selectedNotice) return [];
    if (selectedNotice.type === 'SELECTED_STUDENTS') return students;
    if (selectedNotice.type === 'SELECTED_TEACHERS') return teachers;
    return [];
  };

  const getRecipientLabel = () => {
    if (!selectedNotice) return '';
    if (selectedNotice.type === 'SELECTED_STUDENTS') return 'Choose Student';
    if (selectedNotice.type === 'SELECTED_TEACHERS') return 'Choose Teacher';
    return '';
  };

  return (
    <div>
      <AdminPanel onToggle={setIsSidebarCollapsed} />

      <div className={`notice-main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <div className="notice-topbar">
          <span className="date-time">TODAY IS {new Date().toLocaleString()}</span>
          <span className="school-name">Semigon Learning</span>
        </div>

        <h3 className="notice-dashboard-title">Notice Quick Links</h3>

        <div className="notice-quick-links">
          {noticeLinks.map((link) => (
            <div
              key={link.type}
              className={`notice-card ${link.className}`}
              onClick={() => handleNoticeClick(link)}
            >
              <div className="notice-left">
                <div className="notice-label">{link.label}</div>
              </div>
              <div className="notice-icon-chip">{link.icon}</div>
            </div>
          ))}
        </div>
      </div>

      {modalOpen && (
        <div
          className="notice-modal-overlay"
          onClick={(e) =>
            e.target.classList.contains('notice-modal-overlay') && setModalOpen(false)
          }
        >
          <div className="notice-modal">
            <h2>{selectedNotice.label}</h2>
            <form onSubmit={handleSubmit}>
              {getRecipients().length > 0 && (
                <label>
                  {getRecipientLabel()}:
               <select
  name="recipientId"
  value={formData.recipientId}
  onChange={handleChange}
  required={selectedNotice.type.startsWith('SELECTED')}
>

                    <option value="">Select</option>
                    {getRecipients().map((r, idx) => {
                      // Safe mapping: use correct field names from API, fallback to idx
                      const id = r.student_id ?? r.teacher_id ?? r.id ?? idx;
                      const name = r.student_name ?? r.teacher_name ?? r.name ?? 'Unknown';
                      return (
                        <option key={`${selectedNotice.type}-${id}`} value={id}>
                          {name}
                        </option>
                      );
                    })}
                  </select>
                </label>
              )}

              <label>
                Title:
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                Details:
                <textarea
                  name="details"
                  value={formData.details}
                  onChange={handleChange}
                />
              </label>

              <div className="notice-modal-actions">
                <button type="submit">Send Notice</button>
                <button type="button" onClick={() => setModalOpen(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ComposeNoticeDashboard;